import styled from "styled-components";

export const MainWrapper = styled.div`
  position: relative;
`;

export const Headline = styled.h2`
  font-size: 24px;
  margin-top: 0px;
`;

export const Table = styled.table`
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background: white;
`;

export const TableRow = styled.tr`
  color: #24006b;
`;

export const PerformanceImg = styled.img`
  width: 150px;
  max-height: 100px;
  object-fit: contain;
  border-radius: 10px;
  overflow: hidden;
  background: #eaecf5;
`;

export const NoticeWrap = styled.div`
  position: relative;
  text-align: center;

  &:hover:after {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &:after {
    background: black;
    width: 50px;
    height: 50px;
    line-height: 50px;
    position: absolute;
    display: inline-block;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%) scale(0);
    transition: 0.3s all;
    border-radius: 50%;
    opacity: 0.5;
    color: white;
    content: "Mehr";
    opacity: 0;
    cursor: pointer;
  }
`;

export const ButtonDownload = styled.div`
  background: #eaecf5;
  border: 1px solid blue;
  margin-right: 10px;
  display: inline-block;
  padding: 2px 5px;
  height: 30px;
  border-radius: 4px;
  line-height: 23px;
  margin-bottom: 12px;
  color: blue;
  cursor: pointer;
  user-select: none;
  &:hover {
    background: blue;
    color: white;
  }

  @media print {
    display: none;
  }
`;

export const Bar = styled.span`
  height: 20px;
  line-height: 20px;
  background: ${({ learningPhase }) => (learningPhase ? "#D9D9D9" : "#556bef")};
  width: ${({ width }) => width};
  border-radius: 0px 5px 5px 0px;
  transition: 0.3s all;
  padding-right: 10px;
  &:hover {
    background: ${({ learningPhase }) => (learningPhase ? "grey" : "blue")};
    color: white;
  }
  display: inline-block;
`;

export const Badge = styled.span`
  border-radius: 3px;
  padding: 3px;
  color: green;
  background: #81c784;
  display: inline-block;
  position: relative;
  top: -1px;
  font-size: 10px;
  margin-left: 4px;
`;

export const BadgeWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  padding: 8px;
  color: #b48b2f;
  background: ${({ bg }) => bg || "#ffd36f"};
  font-size: 18px;
  height: 40px;
  width: 40px;
`;

export const BarLabel = styled.span`
  margin-left: 20px;
  color: #556bef;
  display: inline-block;
  position: relative;
  top: 0px;
`;

export const Thead = styled.thead`
  color: #2f2f2f;
  font-weight: bold;
`;

export const HeadTd = styled.td`
  padding: 10px;
  border: 1px solid #e91e63;
  background: #e91e63;
  color: white;
  text-decoration: ${(props) => (props.isActive ? "underline" : "none")};
  cursor: pointer;
  user-select: none;
  text-align: center;
`;

export const Td = styled.td`
  border: 1px solid #f1f1f1;
`;

export const CreativeIndex = styled.td`
  border: 1px solid #f1f1f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 160px;
`;

export const StrongTd = styled.td`
  border: 1px solid #f1f1f1;
  font-weight: bold;
  color: #81c784;
`;

export const Warning = styled.div`
  margin-right: 10px;
  padding: 8px 10px;
  border-radius: 5px;
  line-height: 23px;
  margin-bottom: 12px;
  background: #ffe4e4;
  color: red;
`;

export const CampaignDuration = styled.div`
  color: rgba(0, 0, 0, 1);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 5px;
  h3 {
    white-space: nowrap;
  }
`;

export const GoodPerformance = styled.div`
  border-radius: 12px;
  padding: 8px 15px;
  background: #baffbe;
  display: inline-block;
  position: relative;
  font-size: 12px;
  text-align: center;
`;

export const BadPerformance = styled.div`
  border-radius: 12px;
  padding: 8px 15px;
  background: #ff94a6;
  display: inline-block;
  position: relative;
  font-size: 12px;
  text-align: center;
`;

export const GatheringData = styled.div`
  border-radius: 12px;
  padding: 8px 15px;
  background: #d9d9d9;
  display: inline-block;
  position: relative;
  font-size: 12px;
  text-align: center;
`;

export const AveragePerformance = styled.div`
  border-radius: 12px;
  padding: 8px 15px;
  background: #ffffd4;
  display: inline-block;
  position: relative;
  font-size: 12px;
  text-align: center;
`;

export const StatusIndicator = styled.div`
  height: 15px;
  width: 15px;
  background-color: ${(props) => (props.status == "ACTIVE" ? "#00FF66" : "#D9D9D9")};
  border-radius: 50%;
  display: inline-block;
  margin-top: 5px;
`;

export const ActiveDays = styled.div`
  padding: 10px;
`;

export const CreativeType = styled.div`
  margin-top: 5px;
`;
